import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import clsx from 'clsx';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { createMuiTheme, MuiThemeProvider } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableFooter from '@material-ui/core/TableFooter';
import { Button, Card, CardContent } from '@material-ui/core';
// import { } from '@material-ui/core';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Divider from '@material-ui/core/Divider';
import ListItemText from '@material-ui/core/ListItemText';
import { useHistory } from 'react-router';
import axios from 'axios';
import { ToWords } from 'to-words';
import moment from 'moment';
import CircularProgress from '@material-ui/core/CircularProgress';
import Logo from '../../../assets/Login_logo.png';
import useStyles from './taxinvoiceStyle';
import { CommonConfig } from '../../../config/common-config';
import LoaderPopUp from '../../../components/loaderpopup/loader';
import SuccessPopUp from '../../../components/loaderpopup/success';
import ErrorPopUp from '../../../components/loaderpopup/error';

const THEME = createMuiTheme({
    typography: {
        spacing: 4,
        useNextVariants: true,
        caption: {
            fontSize: 13,
            fontWeight: 'bold',
        },
        body1: {
            fontSize: 12,
        },
        body2: {
            fontSize: 12,
            fontWeight: 'bold',
        },
    },
    overrides: {
        MuiTableCell: {
            root: {
                borderBottom: 'none',
            },
            head: {
                backgroundColor: '#e9e9e9',
                border: '1px solid',
                fontWeight: 'bold',
                textAlign: 'center',
            },
            body: {
                borderRight: '1px solid',
                textAlign: 'left',
            },
            footer: {
                backgroundColor: '#e9e9e9',
                border: '1px solid',
                color: '#000000',
            },
        },
        MuiDivider: {
            root: {
                backgroundColor: '#000000',
                width: '100%',
                marginTop: '10px',
                marginBottom: '10px',
            },
        },
    },
});

function TaxInvoice(props) {
    const classes = useStyles();
    const history = useHistory();
    const toWords = new ToWords();

    const clientId = history.location && history.location.state ? history.location.state.clientId : '';
    const clientData = history.location && history.location.state ? history.location.state.clientData : '';
    const [invoiceData, setInvoiceData] = useState('');
    const [particularLen, setParticularLen] = useState('');
    const [putData, setPutData] = useState([]);
    const [showLoader, setShowLoader] = useState(false);
    const [successpop, setSuccessPop] = useState(false);
    const [editpop, setEditPop] = useState(false);
    const [errorpop, setErrorPop] = useState(false);
    const [errorMsgGenerateRecceipt, setErrorMsgGenerateRecceipt] = useState('');
    const [loaderText, setLoaderText] = useState('Fetching data...');
    const [isDisable, setIsDisable] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.userType;

    const [IMCLogo, setIMCLogo] = useState('');
    const [IMCLogoDefault, setIMCLogoDefault] = useState('');
    const [logoEmpty, setLogoEmpty] = useState('');

    ////console.log('USER TYPEEEEEE----->',usertype);

    const axiosConfig = {
        headers: {
            Authorization: bearerToken,
        },
    };
    // const handleClick = () => {
    //     history.push('/invoice');
    // };

    useEffect(() => {
        axios
            .get(`${CommonConfig.dev.baseUrl}/api/auth/get-imc-logo/${clientData.tennant_name}`)
            .then((response) => {
                // console.log('logoResponse', response);
                setIMCLogo(response.config.url);
                setLogoEmpty(response.data);
                if (response.status === 204) {
                    setIMCLogoDefault(response.status);
                }
            })
            .catch(() => {});
        // console.log("clientData", clientData);
        const postData = {
            buyerId: clientId,
            agreementReference: clientData.agreementrefNo,
            agreementReferenceDate: clientData.agreementRefDate,
            description: clientData.description,
        };
        // console.log('let', postData);
        // console.log('cdata', clientData);

        axios
            .post(`${CommonConfig.dev.baseUrl}/api/auth/generate-invoice`, postData, axiosConfig)
            .then((res) => {
                const apiInvoiceData = res.data.invoice;
                // console.log('DATAAAAAAAA REFERENCEEE----->', apiInvoiceData);
                setInvoiceData(res.data);
                setParticularLen(clientData.particulars.length);

                // console.log('cdata', res.data);
                // console.log('cdata', clientData.particulars);

                const putArr = {
                    invoiceId: apiInvoiceData.id,
                    invoiceNumber: apiInvoiceData.invoiceNumber,
                    totalAmount: numberWithCommas(clientData.total),
                    total: numberWithCommas(clientData.total),
                    buyerId: clientId,
                    gstin: apiInvoiceData.gstin,
                    pan: apiInvoiceData.pan,
                    msme_regnno: apiInvoiceData.msme_regnno,
                    buyerGstin: apiInvoiceData.buyerGstin,
                    buyer_pan: apiInvoiceData.buyer_pan,
                    // agreementReference: apiInvoiceData.agreementReference,
                    agreementReference: clientData.agreementrefNo,
                    agreementReferenceDate: clientData.agreementRefDate,
                    buyerDate: apiInvoiceData.buyerDate,
                    subTotal: decimalCheck(clientData.sub_total2),
                    outputIgst: decimalCheck(clientData.igst_amount),
                    outputCgst: decimalCheck(clientData.cgst_amount),
                    outputSgst: decimalCheck(clientData.sgst_amount),
                    subtotalGst: decimalCheck(clientData.sub_total2),
                    totalInwords: clientData.total,
                    igstPercent: clientData.igst,
                    cgstPercent: clientData.cgst,
                    sgstPercent: clientData.sgst,
                    amountChargeable: numberWithCommas(clientData.total),
                    taxAmount: numberWithCommas(clientData.tax_amount),
                    companybankDetails: apiInvoiceData.companybankDetails,
                    dateCreated: apiInvoiceData.dateCreated,
                    dateModified: apiInvoiceData.dateModified,
                    isActive: apiInvoiceData.isActive,
                    invoiceUrl: apiInvoiceData.invoiceUrl,
                    paymentId: apiInvoiceData.paymentId,
                    taxAmountInWords: clientData.tax_amount ? toWords.convert(clientData.tax_amount, { currency: true }) : '',
                    gstAmtInWords: clientData.sub_total2 ? toWords.convert(clientData.sub_total2, { currency: true }) : '',
                    totalInwords: clientData.total ? toWords.convert(clientData.total, { currency: true }) : '',
                    isIGST: clientData && clientData.isIGST,
                };

                const pArr = [];
                // console.log('Details of Buyer', pArr);
                let i = 0;
                clientData.particulars.map((value, index) => {
                    pArr[i] = {
                        invoiceId: apiInvoiceData.id,
                        particularsText: value.name,
                        hsnSac: value.hsn,
                        rate: value.hsn,
                        // amount: parseFloat(value.amount),
                        // amount: value.amount.replace(/\,/g, ''),
                        amount: numberWithCommas(value.amount.replace(/\,/g, '')),
                        description: value.description,
                        isTaxable: true,
                    };
                    i++;
                    return true;
                });

                clientData.reimbursement.map((value, index) => {
                    pArr[i] = {
                        invoiceId: apiInvoiceData.id,
                        particularsText: value.name,
                        hsnSac: value.hsn,
                        rate: value.hsn,
                        amount: numberWithCommas(value.amount.replace(/\,/g, '')),
                        description: value.description,
                        isTaxable: false,
                    };
                    i++;
                    return true;
                });

                putArr.particulars = pArr;
                setPutData(putArr);
                // console.log('put arr', putArr);
            })
            // .catch((e) => setLoaderText('No data found..'));
            .catch((e) => {});
    }, [userToken]);

    const handleGenerate = () => {
        setShowLoader(true);
        setIsDisable(true);

        console.log('putData', putData);
        console.log('put data', putData);
        axios
            .put(`${CommonConfig.dev.baseUrl}/api/auth/generate-invoice`, putData, axiosConfig)
            .then((res) => {
                // console.log("put res", res);
                if (res.data) {
                    setShowLoader(false);
                    setSuccessPop(true);
                    setTimeout(() => {
                        history.push({
                            pathname: '/menu/genInvoices',
                        });
                    }, 3000);
                }
            })
            .catch((e) => {
                const errResult = e.response;
                if (errResult.data) {
                    setShowLoader(false);
                    setErrorPop(true);
                    setTimeout(() => {
                        setErrorPop(false);
                    }, 5000);
                    setErrorMsgGenerateRecceipt(errResult.data.message);
                }
            });
    };

    const handleEdit = () => {
        setShowLoader(true);
        setTimeout(() => {
            history.push({
                pathname: '/menu/updateInvoice',
                // clientId,
                // clientData,
                state: { clientId, clientData },
            });
        }, 1000);
    };

    //decimal value
    const decimalCheck = (num) => {
        let n;
        if (Number.isInteger(num)) {
            n = num;
        } else {
            n = num.toFixed(2);
        }
        return numberWithCommas(n);
    };

    //append comma
    function numberWithCommas(x) {
        x = x.toString();
        const IndianCur = new Intl.NumberFormat('en-IN').format(parseFloat(x.replace(/,/g, '')));
        return IndianCur;
    }

    //console.log('ClientDataDetails', clientData);
    const invoiceData1 = invoiceData.invoice;
    //console.log('invoiceData1', invoiceData.invoice);
    const invoiceData2 = invoiceData1 && invoiceData1.advithAddress;
    //console.log('invoiceDataAAAAA', invoiceData2);
    //console.log('Dataaaaaa', invoiceData2);

    // state = {
    //     invoiceData2: [],
    //     invoiveDataValue: '',
    // };

    // addSelectorValue = (e) => {
    //     e.preventDefault();
    //     this.setState(({ invoiceData2, invoiceData2 }) => ({
    //         invoiveDataValue: [...invoiveDataValue, ...invoiceData2.split(',')],
    //         invoiceData2: '',
    //     }));
    // };

    // const [inVoiceArr, setInvoiceArr] = useState([]);
    // setInvoiceArr(invoiceData2.toString().split(','));
    //console.log('adress', inVoiceArr);

    // if (!invoiceData) {
    //     return <div>{/* <span style={{ fontSize: '14px', fontWeight: '700' }}>{loaderText}</span> */}</div>;
    // }

    return (
        <div className={classes.paddingCard}>
            {showLoader ? <LoaderPopUp showLoader={showLoader} /> : null}
            {successpop ? (
                <SuccessPopUp open={successpop} showSuccess={successpop} title="Invoice generated and E-mail has been sent" />
            ) : null}
            {errorpop ? <ErrorPopUp open={errorpop} showError={errorpop} title={errorMsgGenerateRecceipt} /> : null}
            {editpop ? <SuccessPopUp open={editpop} showSuccess={editpop} title="Details updated successfully" /> : null}
            <Card className={classes.clientCard}>
                <CardContent className="client-heading">
                    <Typography variant="h5">Tax Invoice</Typography>
                </CardContent>
                <CardContent className={classes.padding0}>
                    {/* <h2 style={{ textAlign: 'center' }}>Tax Invoice</h2> */}
                    <MuiThemeProvider theme={THEME}>
                        <Grid container spacing={0} direction="row" justify="space-between" className={classes.bgLightGrey}>
                            {/* <Grid item xs={6} className={classes.logoBlock}> */}
                            <Grid item sm={3} xs={12} className={classes.paddingCard2035}>
                                <div className="logoCss">
                                    {logoEmpty === '' ? (
                                        IMCLogoDefault === 204 ? (
                                            <div>
                                                <img width="180px" alt="Advith Consulting" src={Logo} />
                                            </div>
                                        ) : (
                                            <img src={''} alt="" />
                                        )
                                    ) : (
                                        // <img alt="" />
                                        <img width="180px" alt="Advith Consulting" src={IMCLogo} />
                                    )}
                                    {/* <img width="180px" alt="Advith Consulting" src={IMCLogo} /> */}
                                </div>
                            </Grid>
                            <Grid item sm={3} xs={12} className={classes.paddingCard2035}>
                                <div className="particulars" style={{ marginTop: '20px' }}>
                                    <span>{invoiceData && invoiceData.invoice && invoiceData.invoice.advithAdminUserName}</span>
                                </div>
                                <div style={{ marginTop: '10px' }}>
                                    {invoiceData && invoiceData.invoice && invoiceData.invoice.advithAddress ? (
                                        <span className="particulars spaceCss">{invoiceData.invoice.advithAddress}</span>
                                    ) : null}
                                </div>
                                <div style={{ marginTop: '5px' }}>
                                    <span>Email: </span>
                                    <span>{invoiceData && invoiceData.invoice && invoiceData.invoice.advithEmail}</span>
                                </div>
                            </Grid>
                            {/* <Grid item xs={6} className={`${classes.borderTop} ${classes.borderRight} ${classes.padding}`}> */}

                            {/* </Grid> */}
                            {/* <Grid
                                container
                                xs={6}
                                style={{ paddingRight: '10px' }}
                                // className={`${classes.borderTop} ${classes.borderRight} ${classes.padding}`}
                                className={`${classes.padding}`}
                            > */}
                            <Grid container sm={6} xs={12} justify="space-between" className={classes.paddingCard2035}>
                                <List className={classes.listRoot}>
                                    <ListItem alignItems="flex-start" className="paddingTB0">
                                        <ListItemText secondary={<span className="particulars">Invoice No:</span>} />
                                        <ListItemText
                                            className="particulars"
                                            secondary={
                                                <span>{invoiceData && invoiceData.invoice && invoiceData.invoice.invoiceNumber}</span>
                                            }
                                        />
                                        {/* <Typography inline className={classes.leftFloat} variant="body1">
                                                Invoice No:
                                            </Typography>
                                            <Typography inline className={classes.leftFloat} variant="body2">
                                                {invoiceData.invoice.invoiceNumber}
                                            </Typography> */}
                                    </ListItem>
                                    {invoiceData && invoiceData.invoice ? (
                                        <ListItem alignItems="flex-start" className="paddingTB0 mb15">
                                            <ListItemText secondary={<span className="particulars">Date:</span>} />
                                            <ListItemText
                                                className="particulars"
                                                // secondary={invoiceData && invoiceData.invoice && invoiceData.invoice.invoiceDate ? {moment(invoiceData.invoice.invoiceDate.split("/").reverse().join("/")).format('DD-MM-YYYY')}</span> : null}
                                                secondary={
                                                    invoiceData && invoiceData.invoice && invoiceData.invoice.invoiceDate ? (
                                                        <span className="particulars">
                                                            {moment(invoiceData.invoice.invoiceDate.split('/').reverse().join('/')).format(
                                                                'DD-MM-YYYY'
                                                            )}
                                                        </span>
                                                    ) : (
                                                        ''
                                                    )
                                                }
                                            />
                                            {/* <Typography inline className={classes.leftFloat} variant="body1">
                                                Date:
                                            </Typography>
                                            <Typography inline className={classes.leftFloat} variant="body2">
                                                {invoiceData.invoice.invoiceDate}
                                            </Typography> */}
                                        </ListItem>
                                    ) : null}
                                    <ListItem alignItems="flex-start" className="paddingTB0">
                                        <ListItemText secondary={<span className="particulars">GSTIN:</span>} />
                                        <ListItemText
                                            className="particulars"
                                            secondary={<span>{invoiceData && invoiceData.invoice && invoiceData.invoice.gstin}</span>}
                                        />
                                        {/* <Typography inline className={classes.leftFloat} variant="body1">
                                                GSTIN:
                                            </Typography>
                                            <Typography inline className={classes.leftFloat} variant="body2">
                                                {invoiceData.invoice.gstin}
                                            </Typography> */}
                                    </ListItem>
                                    <ListItem alignItems="flex-start" className="paddingTB0">
                                        <ListItemText secondary={<span className="particulars">PAN:</span>} />
                                        <ListItemText
                                            className="particulars"
                                            secondary={<span>{invoiceData && invoiceData.invoice && invoiceData.invoice.pan}</span>}
                                        />
                                        {/* <Typography inline className={classes.leftFloat} variant="body1">
                                                PAN:
                                            </Typography>
                                            <Typography inline className={classes.leftFloat} variant="body2">
                                                {invoiceData.invoice.pan}
                                            </Typography> */}
                                    </ListItem>
                                    <ListItem alignItems="flex-start" className="paddingTB0 mb15">
                                        <ListItemText secondary={<span className="particulars">MSME Regn No:</span>} />
                                        <ListItemText
                                            className="particulars"
                                            secondary={<span>{invoiceData && invoiceData.invoice && invoiceData.invoice.msme_regnno}</span>}
                                        />
                                        {/* <Typography inline className={classes.leftFloat} variant="body1">
                                                MSME Regn No:
                                            </Typography>
                                            <Typography inline className={classes.leftFloat} variant="body2">
                                                {invoiceData.invoice.msme_regnno}
                                            </Typography> */}
                                    </ListItem>
                                    {/* {usertype === 'SUPERADMIN' ?  (<ListItem alignItems="flex-start" className="paddingTB0">
                                        <ListItemText secondary={<span className="particulars">Agreement Reference:</span>} />
                                        <ListItemText
                                            secondary={<span className="particulars">{clientData.agreementrefNo}</span>}
                                        />
                                        
                                    </ListItem>) : 
                                    <ListItem alignItems="flex-start" className="paddingTB0">
                                    <ListItemText secondary={<span className="particulars">Engagement Reference:</span>} />
                                    <ListItemText
                                        secondary={<span className="particulars">{invoiceData.invoice.serviceId}</span>}
                                    />
                                    
                                </ListItem>} */}
                                    {/* <ListItem alignItems="flex-start" className="paddingTB0">
                                        <ListItemText secondary={<span className="particulars">Agreement Reference:</span>} />
                                        <ListItemText className="particulars"
                                            secondary={<span>{clientData.agreementrefNo}</span>}
                                        />

                                    </ListItem> */}
                                </List>
                            </Grid>
                            {/* <Grid container xs={6} justify="space-between">
                                    <Typography inline align="left" variant="body1">
                                        Date:
                                    </Typography>
                                    <Typography inline align="right" variant="body2">
                                        {invoiceData.invoice.invoiceDate}
                                    </Typography>
                                </Grid> */}

                            {/* <Grid container xs={6} justify="space-between">
                                    <Typography inline align="left" variant="body1">
                                        GSTIN:
                                    </Typography>
                                    <Typography inline align="right" variant="body2">
                                        {invoiceData.invoice.gstin}
                                    </Typography>
                                </Grid>
                                <Grid container xs={6} justify="space-between">
                                    <Typography inline align="left" variant="body1">
                                        PAN:
                                    </Typography>
                                    <Typography inline align="right" variant="body2">
                                        {invoiceData.invoice.pan}
                                    </Typography>
                                </Grid>
                                <Grid container xs={6} justify="space-between">
                                    <Typography inline align="left" variant="body1">
                                        MSME Regn No:
                                    </Typography>
                                    <Typography inline align="right" variant="body2">
                                        {invoiceData.invoice.msme_regnno}
                                    </Typography>
                                </Grid> */}
                            {/* </Grid> */}
                            <Divider />
                            <Grid
                                container
                                xs={12}
                                // className={`${classes.buyerSection} ${classes.borderTop} ${classes.borderRight}`}
                                // style={{ borderLeft: '1px solid' }}
                            >
                                <Grid item sm={6} xs={12} className={classes.paddingCard2035}>
                                    <div>
                                        <span className="particulars">Buyer</span>
                                    </div>
                                    <div className="particulars" style={{ marginTop: '10px' }}>
                                        <span>{invoiceData && invoiceData.invoice && invoiceData.invoice.buyerName}</span>
                                    </div>
                                    <div style={{ marginTop: '10px' }}>
                                        <span className="particulars spaceCssBuy">
                                            {invoiceData && invoiceData.invoice && invoiceData.invoice.buyerAddress}
                                        </span>
                                    </div>
                                    {/* <div style={{ marginTop: '5px' }}>
                                        <span>Email: </span>
                                        <span>{invoiceData && invoiceData.invoice && invoiceData.invoice.buyerEmail}</span>
                                    </div> */}
                                </Grid>

                                <Grid
                                    container
                                    xs={6}
                                    justify="space-between"
                                    className={classes.paddingCard2035}
                                    // style={{ paddingRight: '10px', height: '50px' }}
                                >
                                    <List className={classes.listRoot}>
                                        <ListItem alignItems="flex-start" className="paddingTB0">
                                            <ListItemText secondary={<span className="particulars">Agreement Reference:</span>} />
                                            <ListItemText className="particulars" secondary={<span>{clientData.agreementrefNo}</span>} />
                                        </ListItem>
                                        <ListItem alignItems="flex-start" className="paddingTB0 mb15">
                                            <ListItemText secondary={<span className="particulars">Date:</span>} />
                                            <ListItemText
                                                className="particulars"
                                                // secondary={<span>{moment(invoiceData.invoice.buyerDate).format('DD-MM-YYYY')}</span>}
                                                secondary={
                                                    <span>
                                                        {clientData && clientData.agreementRefDate
                                                            ? moment(clientData.agreementRefDate).format('DD-MM-YYYY')
                                                            : ''}
                                                    </span>
                                                }
                                            />
                                        </ListItem>
                                        <ListItem alignItems="flex-start" className="paddingTB0">
                                            <ListItemText secondary={<span className="particulars">GSTIN:</span>} />
                                            <ListItemText
                                                className="particulars"
                                                secondary={
                                                    <span>{invoiceData && invoiceData.invoice && invoiceData.invoice.buyerGstin}</span>
                                                }
                                            />
                                            {/* <Typography inline className={classes.leftFloat} variant="body1">
                                                Invoice No:
                                            </Typography>
                                            <Typography inline className={classes.leftFloat} variant="body2">
                                                {invoiceData.invoice.invoiceNumber}
                                            </Typography> */}
                                        </ListItem>
                                        <ListItem alignItems="flex-start" className="paddingTB0">
                                            <ListItemText secondary={<span className="particulars">PAN:</span>} />
                                            <ListItemText
                                                className="particulars"
                                                secondary={
                                                    <span>{invoiceData && invoiceData.invoice && invoiceData.invoice.buyer_pan}</span>
                                                }
                                            />
                                            {/* <Typography inline className={classes.leftFloat} variant="body1">
                                                Invoice No:
                                            </Typography>
                                            <Typography inline className={classes.leftFloat} variant="body2">
                                                {invoiceData.invoice.invoiceNumber}
                                            </Typography> */}
                                        </ListItem>
                                    </List>
                                    {/* <div className={classes.displayFlex} style={{ height: '20px' }}>
                                        <Typography inline align="left" variant="body1">
                                            GSTIN:
                                        </Typography>
                                        <Typography inline align="right" variant="body2">
                                            {invoiceData.invoice.buyerGstin}
                                        </Typography>
                                    </div> */}
                                    {/* <div className={classes.displayFlex}>
                                        <Typography inline align="left" variant="body1">
                                            PAN:
                                        </Typography>
                                        <Typography inline align="right" variant="body2">
                                            {invoiceData.invoice.buyer_pan}
                                        </Typography>
                                    </div> */}
                                </Grid>
                            </Grid>
                            {/* <Grid
                                container
                                xs={3}
                                className={`${classes.borderTop} ${classes.borderRight} ${classes.padding}`}
                                style={{ paddingRight: '10px' }}
                            > */}
                            {/* <Grid container xs={10} justify="space-between">
                                    <Typography inline align="left" variant="body1">
                                        Agreement Reference:
                                    </Typography>
                                    <Typography inline align="right" variant="body2">
                                        {invoiceData.invoice.agreementReference}
                                    </Typography>
                                </Grid>
                                <Grid container xs={10} justify="space-between">
                                    <Typography inline align="left" variant="body1">
                                        Date:
                                    </Typography>
                                    <Typography inline align="right" variant="body2">
                                        {invoiceData.invoice.buyerDate}
                                    </Typography>
                                </Grid> */}
                            {/* </Grid> */}
                        </Grid>

                        <TableContainer component={Paper}>
                            <Table>
                                <colgroup>
                                    <col style={{ width: '10%' }} />
                                    <col style={{ width: '45%' }} />
                                    <col style={{ width: '20%' }} />
                                    <col style={{ width: '12.5%' }} />
                                    <col style={{ width: '12.5%' }} />
                                </colgroup>
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.bgNone}>SL No.</TableCell>
                                        <TableCell className={classes.bgNone}>Particulars</TableCell>
                                        <TableCell className={classes.bgNone}>HSN/SAC</TableCell>
                                        <TableCell className={classes.bgNone}>Rate</TableCell>
                                        <TableCell className={classes.bgNone}>Amount in INR</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {clientData.particulars.length > 0 &&
                                        clientData.particulars.map((value, index) => (
                                            <TableRow>
                                                <TableCell align="center" className={clsx(classes.bgNone, classes.fontNormal)}>
                                                    {index + 1}.
                                                </TableCell>
                                                <TableCell className={clsx(classes.bgNone, classes.fontNormal)}>
                                                    {value.name} {value.description !== '' ? '(' + value.description + ')' : ''}
                                                    {/* {value.name} ({clientData.description ? clientData.description : 'If Any'}) */}
                                                </TableCell>
                                                <TableCell align="right" className={clsx(classes.bgNone, classes.fontNormal)}>
                                                    {value.hsn}
                                                </TableCell>
                                                <TableCell align="right" className={clsx(classes.bgNone, classes.fontNormal)} />
                                                <TableCell align="right" className={clsx(classes.bgNone, classes.fontNormal)}>
                                                    {value.amount}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    {clientData.particulars.length > 0 && (
                                        <>
                                            <TableRow>
                                                <TableCell align="center" className={clsx(classes.borderLeft, classes.bgNone)} />
                                                <TableCell className={clsx(classes.bgNone, classes.fontNormal)}>Sub-Total</TableCell>
                                                <TableCell align="right" className={classes.bgNone} />
                                                <TableCell align="right" className={classes.bgNone} />
                                                <TableCell align="right" className={clsx(classes.bgNone, classes.fontNormal)}>
                                                    {numberWithCommas(clientData.sub_total1)}
                                                </TableCell>
                                            </TableRow>
                                            {clientData && clientData.isIGST === 'IGST' ? (
                                                <TableRow>
                                                    <TableCell
                                                        align="center"
                                                        className={clsx(classes.borderLeft, classes.bgNone, classes.fontNormal)}
                                                    >
                                                        {/* {particularLen + 1}. */}
                                                    </TableCell>
                                                    <TableCell className={clsx(classes.bgNone, classes.fontNormal)}>Output IGST</TableCell>
                                                    <TableCell align="right" className={classes.bgNone} />

                                                    <TableCell align="right" className={clsx(classes.bgNone, classes.fontNormal)}>
                                                        {clientData.igst}%
                                                    </TableCell>
                                                    <TableCell align="right" className={clsx(classes.bgNone, classes.fontNormal)}>
                                                        {decimalCheck(clientData.igst_amount)}
                                                    </TableCell>
                                                </TableRow>
                                            ) : null}
                                            {clientData && clientData.isIGST !== 'IGST' ? (
                                                <TableRow>
                                                    <TableCell
                                                        align="center"
                                                        className={clsx(classes.borderLeft, classes.bgNone, classes.fontNormal)}
                                                    >
                                                        {/* {clientData && clientData.isIGST !== 'IGST' ? particularLen + 1 : particularLen + 2}. */}
                                                    </TableCell>
                                                    <TableCell className={clsx(classes.bgNone, classes.fontNormal)}>Output CGST</TableCell>
                                                    <TableCell align="right" className={classes.bgNone} />

                                                    <TableCell align="right" className={clsx(classes.bgNone, classes.fontNormal)}>
                                                        {clientData.cgst}%
                                                    </TableCell>
                                                    <TableCell align="right" className={clsx(classes.bgNone, classes.fontNormal)}>
                                                        {decimalCheck(clientData.cgst_amount)}
                                                    </TableCell>
                                                </TableRow>
                                            ) : null}
                                            {clientData && clientData.isIGST !== 'IGST' ? (
                                                <TableRow>
                                                    <TableCell
                                                        align="center"
                                                        className={clsx(classes.borderLeft, classes.bgNone, classes.fontNormal)}
                                                    >
                                                        {/* {clientData && clientData.isIGST !== 'IGST' ? particularLen + 2 : particularLen + 3}. */}
                                                    </TableCell>
                                                    <TableCell className={clsx(classes.bgNone, classes.fontNormal)}>Output SGST</TableCell>
                                                    <TableCell align="right" className={classes.bgNone} />

                                                    <TableCell align="right" className={clsx(classes.bgNone, classes.fontNormal)}>
                                                        {' '}
                                                        {clientData.sgst}%
                                                    </TableCell>
                                                    <TableCell align="right" className={clsx(classes.bgNone, classes.fontNormal)}>
                                                        {decimalCheck(clientData.sgst_amount)}
                                                    </TableCell>
                                                </TableRow>
                                            ) : null}
                                            <TableRow>
                                                <TableCell align="center" className={clsx(classes.borderLeft, classes.bgNone)} />
                                                <TableCell className={clsx(classes.bgNone, classes.fontNormal)}>Sub-Total</TableCell>
                                                <TableCell align="right" className={classes.bgNone} />
                                                <TableCell align="right" className={classes.bgNone} />
                                                <TableCell align="right" className={clsx(classes.bgNone, classes.fontNormal)}>
                                                    {decimalCheck(clientData.sub_total2)}
                                                </TableCell>
                                            </TableRow>
                                        </>
                                    )}

                                    {clientData.reimbursement.length > 0 &&
                                        clientData.reimbursement.map((value, index) => (
                                            <TableRow>
                                                <TableCell
                                                    align="center"
                                                    className={clsx(classes.borderLeft, classes.bgNone, classes.fontNormal)}
                                                >
                                                    {particularLen ? <span>{particularLen + index + 1}.</span> : <span>{index + 1}.</span>}
                                                </TableCell>
                                                <TableCell className={clsx(classes.bgNone, classes.fontNormal)}>
                                                    {value.name} {value.description !== '' ? '(' + value.description + ')' : ''}
                                                    {/* ({clientData.description ? clientData.description : ''}) */}
                                                </TableCell>
                                                <TableCell align="right" className={clsx(classes.bgNone, classes.fontNormal)}>
                                                    {value.hsn}
                                                </TableCell>
                                                <TableCell align="right" className={clsx(classes.bgNone, classes.fontNormal)} />
                                                <TableCell align="right" className={clsx(classes.bgNone, classes.fontNormal)}>
                                                    {value.amount}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                </TableBody>
                                <TableFooter className={classes.borderT}>
                                    <TableRow>
                                        <TableCell className={classes.bgNone} />
                                        <TableCell align="right" className={classes.bgNone}>
                                            Total<span className={classes.roundedOff}>(rounded off to the nearest rupee)</span>
                                        </TableCell>
                                        <TableCell align="right" className={classes.bgNone} />
                                        <TableCell align="right" className={classes.bgNone} />
                                        <TableCell align="right" className={classes.bgNone}>
                                            {numberWithCommas(clientData.total)}
                                        </TableCell>
                                    </TableRow>
                                </TableFooter>
                            </Table>
                        </TableContainer>

                        <Grid container className={classes.bgLightGrey}>
                            <Grid item xs={12} className={classes.paddingCard2035}>
                                <Typography variant="body1" className={classes.fontRubik}>
                                    Total Amount (in words):
                                </Typography>
                                <Typography variant="body2" className={` ${classes.fontRubik} ${classes.fontRubikBold}`}>
                                    INR {toWords.convert(clientData.total, { currency: true })}
                                </Typography>
                            </Grid>
                            <Grid item sm={6} xs={12} className={classes.paddingCard2035}>
                                <Typography variant="body1" className={classes.fontRubik}>
                                    Amount Chargable to GST (in words):
                                </Typography>
                                <Typography variant="body2" className={` ${classes.fontRubik} ${classes.fontRubikBold}`}>
                                    INR {toWords.convert(clientData.sub_total1, { currency: true })}
                                </Typography>
                            </Grid>
                            <Grid item sm={6} xs={12} className={classes.paddingCard2035}>
                                <Typography variant="body1" className={classes.fontRubik}>
                                    Tax Amount (in words):
                                </Typography>
                                <Typography variant="body2" className={` ${classes.fontRubik} ${classes.fontRubikBold}`}>
                                    INR {toWords.convert(clientData.sub_total2, { currency: true })}
                                </Typography>
                            </Grid>
                            <Grid item sm={6} xs={12} className={classes.paddingCard2035}>
                                <Typography variant="caption" className={` ${classes.fontRubik} ${classes.fontRubikBold}`}>
                                    Declaration
                                </Typography>
                                {invoiceData && invoiceData.Declaration && invoiceData.Declaration.length ? (
                                    <Typography variant="body1" className={classes.fontRubik}>
                                        <div
                                            style={{
                                                whiteSpace: 'break-spaces',
                                                marginTop: '0',
                                                paddingBottom: '12px',
                                                wordBreak: 'break-all',
                                            }}
                                        >
                                            {invoiceData.Declaration.map((values) => (
                                                <span>{values}</span>
                                            ))}
                                        </div>
                                    </Typography>
                                ) : null}
                                {/* <Typography variant="body2" className={` ${classes.fontRubik} ${classes.fontRubikBold}`}>
                                    Description
                                </Typography>
                                <Typography variant="body1" className={classes.fontRubik}>
                                    {clientData.description ? clientData.description : 'If Any'}
                                </Typography> */}
                            </Grid>
                            {invoiceData && invoiceData.bankDetails ? (
                                <Grid item sm={6} xs={12} className={classes.paddingCard2035}>
                                    <Typography variant="caption" className={` ${classes.fontRubik} ${classes.fontRubikBold}`}>
                                        Company&apos;s Bank Details:
                                    </Typography>
                                    <div className="displayFlex">
                                        <Typography variant="body1" className={classes.fontRubik}>
                                            Bank Name:
                                        </Typography>
                                        <Typography variant="body2" className={` ${classes.fontRubik} ${classes.fontRubikBold}`}>
                                            {invoiceData.bankDetails[0].bankName}
                                        </Typography>
                                    </div>
                                    <div className="displayFlex">
                                        <Typography variant="body1" className={classes.fontRubik}>
                                            A/c No.:
                                        </Typography>
                                        <Typography variant="body2" className={` ${classes.fontRubik} ${classes.fontRubikBold}`}>
                                            {invoiceData.bankDetails[0].accountNumber}
                                        </Typography>
                                    </div>
                                    <div className="displayFlex">
                                        <Typography variant="body1" className={classes.fontRubik}>
                                            Branch & IFSC Code:
                                        </Typography>
                                        <Typography variant="body2" className={` ${classes.fontRubik} ${classes.fontRubikBold}`}>
                                            {invoiceData.bankDetails[0].branch} & {invoiceData.bankDetails[0].ifscCode}
                                        </Typography>
                                    </div>
                                </Grid>
                            ) : null}
                            <Grid item xs={12} style={{ textAlign: 'center' }}>
                                <i style={{ fontSize: '13px' }}>This is a system generated invoice. Hence no signature is required</i>
                            </Grid>
                        </Grid>
                    </MuiThemeProvider>
                </CardContent>
            </Card>
            <div className="footer-button">
                <ul>
                    <li>
                        <Button
                            // variant="contained"
                            color="primary"
                            className="buttonnext txt-cap"
                            onClick={handleEdit}
                            disabled={isDisable}
                        >
                            Edit
                        </Button>
                    </li>
                    <li>
                        <Button color="primary" className="buttonnext txt-cap" onClick={handleGenerate}>
                            Generate and send E-Mail
                        </Button>
                    </li>
                </ul>
            </div>
            <div className={classes.errorDiv}>{errorMsg}</div>
        </div>
    );
}
export default TaxInvoice;
